import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { UnderPaidAgingIncomingInvoiceTodoFormContainerProps } from "models/propTypes/incomingInvoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FormFieldConstants } from "utils/constants";
import { AgingIncomingInvoiceUnderPaidActions } from "models/enums/incomingInvoice";
import { IncomingInvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import UnderPaidAgingIncomingInvoiceTodoForm from "./underPaidAgingIncomingInvoiceTodoForm";
//#endregion
import * as Yup from "yup";
import { UtilsHelper } from "utils/helpers";

const UnderPaidAgingIncomingInvoiceTodoFormContainer: ForwardRefRenderFunction<
  FormHandles,
  UnderPaidAgingIncomingInvoiceTodoFormContainerProps
> = (props, ref) => {
  const initialValues: IncomingInvoiceFormTypes.UnderPaidAgingInvoiceTodo = {
    paymentNumber: UtilsHelper.isEmpty(props.invoice.bg) ? props.invoice.pg : props.invoice.bg,
    explanation: "",
  };
  const validationSchema = Yup.object<IncomingInvoiceFormTypes.UnderPaidAgingInvoiceTodo>({
    action: Yup.number().required(TranslationKeys.Validations.Required),
    paymentDate: Yup.date().when(
      FormFieldConstants.IncomingInvoice.UnderPaidAgingInvoiceTodo.Action,
      ([action], schema: Yup.DateSchema) =>
        (action === AgingIncomingInvoiceUnderPaidActions.UnderpaidHasBeenPaidInfoSupplied &&
          schema.required(TranslationKeys.Validations.Required)) ||
        schema
    ),
    plannedPaymentDate: Yup.date().when(
      FormFieldConstants.IncomingInvoice.UnderPaidAgingInvoiceTodo.Action,
      ([action], schema: Yup.DateSchema) =>
        (action === AgingIncomingInvoiceUnderPaidActions.UnderpaidCreatePayment &&
          schema.required(TranslationKeys.Validations.Required)) ||
        schema
    ),
    explanation: Yup.string().when(
      [FormFieldConstants.IncomingInvoice.OverPaidAgingInvoiceTodo.Action],
      ([action], schema: Yup.StringSchema) =>
        (action === AgingIncomingInvoiceUnderPaidActions.UnderpaidOtherInfoSupplied &&
          schema.required(TranslationKeys.Validations.Required)) ||
        schema
    ),
    bg: Yup.string(),
  });

  return (
    <UnderPaidAgingIncomingInvoiceTodoForm
      ref={ref}
      {...props}
      defaultValues={initialValues}
      validationSchema={validationSchema}
    />
  );
};

export default forwardRef(UnderPaidAgingIncomingInvoiceTodoFormContainer);
